import { z } from 'zod';

import {
  EmployeeStatus,
  ProbationReviewFlag,
  ProbationReviewReviewStatus,
  ProbationReviewView,
  ProbationStatus,
} from '@/common/graphql';
import { DateUtils } from '@/common/utils';

import { IsoDateFilter } from './iso-date';

export const ProbationReviewFilter = z.object({
  keyword: z.string().nullable().optional().catch(null),
  page: z.number().catch(1),
  // The saved view (tab); Needs Action is the default.
  view: z.nativeEnum(ProbationReviewView).catch(ProbationReviewView.NeedsAction),
  // The month whose review due dates the list shows (default: the current month).
  reviewDueMonth: z
    .string()
    .regex(/^\d{4}-(0[1-9]|1[0-2])$/)
    .catch(() => DateUtils.getCurrentYearMonth()),
  companyIds: z.array(z.string()).catch([]),
  locationIds: z.array(z.string()).catch([]),
  businessUnitIds: z.array(z.string()).catch([]),
  probationStatuses: z.array(z.nativeEnum(ProbationStatus)).catch([]),
  reviewStatuses: z.array(z.nativeEnum(ProbationReviewReviewStatus)).catch([]),
  probationEndDateFrom: IsoDateFilter,
  probationEndDateTo: IsoDateFilter,
  flag: z.nativeEnum(ProbationReviewFlag).nullable().optional().catch(null),
  employeeStatuses: z.array(z.nativeEnum(EmployeeStatus)).catch([EmployeeStatus.Active]),
});
export type ProbationReviewFilterType = z.infer<typeof ProbationReviewFilter>;
